import { render, staticRenderFns } from "./creator-v3-separator.vue?vue&type=template&id=cc84f470"
import script from "./creator-v3-separator.js?vue&type=script&lang=js&external"
export * from "./creator-v3-separator.js?vue&type=script&lang=js&external"
import style0 from "./creator-v3-separator.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports